import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function brandReducer(state = initialState.brand, action) {
  if (action.type === types.LOADED_BRAND_DATA_SUCCESS ) {
    return action.brand;
  }

  return state;
}
